(function () {
  function initForms(container) {
    // Quantity steppers
    container.querySelectorAll('.ecoreina-xsell-qty').forEach(function (qty) {
      if (qty._xsInit) return;
      qty._xsInit = true;
      var val = qty.querySelector('.ecoreina-xsell-qty-val');
      qty.querySelector('.ecoreina-xsell-qty-dec').addEventListener('click', function () {
        var n = parseInt(val.textContent) || 1;
        if (n > 1) val.textContent = n - 1;
      });
      qty.querySelector('.ecoreina-xsell-qty-inc').addEventListener('click', function () {
        var n = parseInt(val.textContent) || 1;
        val.textContent = n + 1;
      });
    });

    // Size selects
    container.querySelectorAll('.ecoreina-xsell-select').forEach(function (sel) {
      if (sel._xsInit) return;
      sel._xsInit = true;
      sel.addEventListener('change', function () {
        var btn = sel.closest('.ecoreina-xsell-form').querySelector('.ecoreina-xsell-btn');
        if (sel.value) {
          btn.dataset.variantId = sel.value;
          btn.disabled = false;
          btn.textContent = 'Agregar al carrito';
        } else {
          delete btn.dataset.variantId;
          btn.disabled = true;
          btn.textContent = 'Seleccionar talla';
        }
      });
    });

    // Fix gap: product-block has flex-grow:1 from carousel CSS, stretching it beyond content.
    // Also handle case where container itself is the ecoreina-xsell-item (MutationObserver node).
    var xsellItems = Array.from(container.querySelectorAll('.ecoreina-xsell-item'));
    if (container.classList && container.classList.contains('ecoreina-xsell-item')) {
      xsellItems.push(container);
    }
    xsellItems.forEach(function (item) {
      var block = item.querySelector('.product-block');
      var blockInner = item.querySelector('.block-inner');
      var detail = item.querySelector('.product-block__detail');
      var form = item.querySelector('.ecoreina-xsell-form');
      if (block) { block.style.flexGrow = '0'; block.style.flexShrink = '0'; }
      if (blockInner) blockInner.style.minHeight = '0';
      if (detail) detail.style.marginBottom = '0';
      if (form) form.style.marginTop = '8px';
    });

    scheduleEqualize();

    // Add to cart buttons
    container.querySelectorAll('.ecoreina-xsell-btn').forEach(function (btn) {
      if (btn._xsInit) return;
      btn._xsInit = true;
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        var form = btn.closest('.ecoreina-xsell-form');
        var qtyEl = form.querySelector('.ecoreina-xsell-qty-val');
        var qty = qtyEl ? (parseInt(qtyEl.textContent) || 1) : 1;
        var orig = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Añadiendo...';
        var params = new URLSearchParams();
        params.append('id', variantId);
        params.append('quantity', qty);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: params.toString()
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'error'); });
            return r.json();
          })
          .then(function () {
            btn.textContent = '✓ Añadido';

            // Scroll to top first so the refresh feels instant
            var scroller = document.querySelector('.cart-drawer__content') ||
                           document.querySelector('.cart-drawer__content-upper') ||
                           document.querySelector('.cart-drawer');
            if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });

            // Trigger the theme's native cart drawer refresh (re-fetches section HTML)
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));

            setTimeout(function () {
              btn.textContent = orig;
              btn.disabled = false;
            }, 2000);
          })
          .catch(function (err) {
            btn.textContent = err.message === 'error' ? 'Error' : (err.message || 'Error');
            btn.disabled = false;
            setTimeout(function () {
              btn.textContent = orig;
            }, 2500);
          });
      });
    });
  }

  var equalizeTimer = null;
  function scheduleEqualize() {
    clearTimeout(equalizeTimer);
    equalizeTimer = setTimeout(function () {
      // Group ecoreina-xsell-items by their parent, equalize product-block__detail heights within each group
      var parents = [];
      document.querySelectorAll('.ecoreina-xsell-item').forEach(function (item) {
        if (parents.indexOf(item.parentElement) === -1) parents.push(item.parentElement);
      });
      parents.forEach(function (parent) {
        var details = Array.from(parent.querySelectorAll('.ecoreina-xsell-item .product-block__detail'));
        details.forEach(function (d) { d.style.minHeight = ''; });
        var maxH = Math.max.apply(null, details.map(function (d) { return d.offsetHeight; }));
        if (maxH > 0) details.forEach(function (d) { d.style.minHeight = maxH + 'px'; });
      });
    }, 150);
  }

  initForms(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initForms(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
